<template>
	<el-menu class="navbar" mode="horizontal">
		<hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
		<!-- <span style="font-size: 14px;color: #FFFFFF;">{{gettime}}</span> -->
		<span @click="changeLangEvent()">
			<img class="langimg" src="../../../assets/images/lang.png">
		</span>
    <div class="iocount" v-if="showIoCount">
      <span style="display: inline-block;margin-right: 20px;">实名认证数量：{{rcount}}</span>
      <span style="display: inline-block;margin-right: 20px;">入金数量：{{incount}}</span>
      <span>出金数量：{{outcount}}</span>
    </div>
		<el-dropdown class="avatar-container" trigger="click">
			<div class="avatar-wrapper">
				{{name}}
				<i class="el-icon-caret-bottom"></i>
			</div>
			<el-dropdown-menu class="user-dropdown" slot="dropdown">
				<router-link class="inlineBlock" to="/">
					<el-dropdown-item>
						{{$t('h.navbar.home')}}
					</el-dropdown-item>
				</router-link>
				<router-link class="inlineBlock" to="/person">
					<el-dropdown-item>
						{{$t('h.navbar.mycenter')}}
					</el-dropdown-item>
				</router-link>
				<el-dropdown-item>
					<span @click.stop="logout">{{$t('h.navbar.outlogin')}}</span>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-dialog :title="$t('h.navbar.editLanguage')" :visible.sync="openlang" width="95%">
			<el-radio v-model="language" border @input="funlang(item.id)" v-for="(item,index) in langlist"
				:key="index" style="margin: 10px 5px;" size="mini">{{item.mc}}</el-radio>
			<span slot="footer" class="dialog-footer">
				<el-button @click="openlang = false" size="mini">{{$t('h.navbar.close')}}</el-button>
			</span>
		</el-dialog>
	</el-menu>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import Breadcrumb from '@/components/Breadcrumb'
	import Hamburger from '@/components/Hamburger'
  import {getReal} from '@/api/user'
  import {
    getWithdrawal
  } from '@/api/assets'
  import {getDeposit} from '@/api/assets'

	export default {
		data() {
			return {
				gettime: '',
				openlang: false,
        incount:0,
        outcount:0,
        rcount:0,
        showIoCount:false,
				language: localStorage.getItem("lang") || "EN",
				langlist: [
          {
          	id: 'en-US',
          	mc: this.$t('h.Langswitch.en')
          },{
						id: 'zh-CN',
						mc: this.$t('h.Langswitch.zh')
					},
					{
						id: 'xi-NI',
						mc: this.$t('h.Langswitch.xi')
					},
					{
						id: 'vi-VN',
						mc: this.$t('h.Langswitch.vi')
					},
					{
						id: 'tu-ER',
						mc: this.$t('h.Langswitch.tu')
					},
					{
						id: 'th-TH',
						mc: this.$t('h.Langswitch.th')
					},
					{
						id: 'pu-YA',
						mc: this.$t('h.Langswitch.pu')
					},
					{
						id: 'jp-JP',
						mc: this.$t('h.Langswitch.jp')
					},
					{
						id: 'id-ID',
						mc: this.$t('h.Langswitch.id')
					},
					{
						id: 'han-YU',
						mc: this.$t('h.Langswitch.han')
					},
					{
						id: 'fa-YU',
						mc: this.$t('h.Langswitch.fa')
					},

					{
						id: 'ar-YU',
						mc: this.$t('h.Langswitch.ar')
					},
				]
			}
		},
		components: {
			Breadcrumb,
			Hamburger
		},
		computed: {
			...mapGetters([
				'sidebar',
				'avatar',
        'name',
        'roles'
			])
		},
		mounted() {
			this.currentTime();
      this.getIoCount();
      if(this.name == "administrator"){
        this.showIoCount = true;
      }else if(this.roles){
        for(var i=0;i<this.roles.length;i++){
          if(this.roles[i] == "财务管理员"){
            this.showIoCount = true;
          }
        }
      }
      console.log("roles:"+JSON.stringify(this.roles));
		},
		methods: {
			toggleSideBar() {
				this.$store.dispatch('ToggleSideBar')
			},
			funlang(id) {
				this.openlang = false
				location.reload(); //重新加载
				switch (id) {
					case 'zh-CN':
						localStorage.setItem("locale", "zh");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "ZH");
						this.language = "ZH";
						break;
					case 'en-US':
						localStorage.setItem("locale", "en");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "EN");
						this.language = "EN";
						break;
					case 'xi-NI':
						localStorage.setItem("locale", "xi");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "XI");
						this.language = "XI";
						break;
					case 'vi-VN':
						localStorage.setItem("locale", "vi");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "VI");
						this.language = "VI";
						break;
					case 'tu-ER':
						localStorage.setItem("locale", "tu");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "TU");
						this.language = "TU";
						break;
					case 'th-TH':
						localStorage.setItem("locale", "th");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "TH");
						this.language = "TH";
						break;
					case 'pu-YA':
						localStorage.setItem("locale", "th");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "TH");
						this.language = "TH";
						break;
					case 'jp-JP':
						localStorage.setItem("locale", "jp");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "JP");
						this.language = "JP";
						break;
					case 'id-ID':
						localStorage.setItem("locale", "id");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "ID");
						this.language = "ID";
						break;
					case 'han-YU':
						localStorage.setItem("locale", "han");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "HAN");
						this.language = "HAN";
						break;
					case 'fa-YU':
						localStorage.setItem("locale", "fa");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "FA");
						this.language = "FA";
						break;
					case 'ar-YU':
						localStorage.setItem("locale", "ar");
						this.$i18n.locale = localStorage.getItem("locale");
						localStorage.setItem("lang", "AR");
						this.language = "AR";
						break;
					default:
						break;
				}
			},
			changeLangEvent() {
				this.openlang = true
			},
			/* getTime: function () {
			  var _this = this;
			  let yy = new Date().getFullYear();
			  var mm =
			    new Date().getMonth() < 10
			      ? "0" + (new Date().getMonth() + 1)
			      : new Date().getMonth() + 1;
			  var dd =
			    new Date().getDate() < 10
			      ? "0" + new Date().getDate()
			      : new Date().getDate();
			  let hh = new Date().getHours();
			  let mf =
			    new Date().getMinutes() < 10
			      ? "0" + new Date().getMinutes()
			      : new Date().getMinutes();
			  let ss =
			    new Date().getSeconds() < 10
			      ? "0" + new Date().getSeconds()
			      : new Date().getSeconds();
			  _this.gettime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
			}, */
			currentTime() {
				// setInterval(this.getTime, 500);
			},
      getIoCount(){
        var that = this;
        var data = {
          checkStatusEnum:"APPLYING",
          isAgent:false,
          pageSize:5,
          pageNum:1
        };
        getWithdrawal(data).then(response => {
          that.outcount = response.data.page.total;
        })
        data = {
          status:"APPLYING",
          pageSize:5,
          pageNum:1
        };
        getDeposit(data).then(response => {
          that.incount = response.data.total;
        })
        data = {
          page:1,
          size:5,
          pageNum:1,
          realNameStatusEnum:"CHECKING"
        }
        getReal(data).then(response => {
          that.rcount = response.data.total;
        })
      },
			logout() {
				console.log("logout------");
				this.$store.dispatch('LogOut').then(() => {
					location.reload() // 为了重新实例化vue-router对象 避免bug
          this.$router.push('/home')
          console.log(123456);
				})
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.navbar {
		background: linear-gradient(88deg, #E33925 0%, #FA4614 48%, #F77428 100%);
		height: 50px;
		line-height: 50px;
		border-radius: 0px !important;

		.hamburger-container {
			line-height: 58px;
			height: 50px;
			float: left;
			padding: 0 10px;
		}

		.screenfull {
			position: absolute;
			right: 90px;
			top: 16px;
			color: red;
		}
    .iocount{
      height: 50px;
      display: inline-block;
      position: absolute;
      right: 200px;
    }
		.avatar-container {
			height: 50px;
			display: inline-block;
			position: absolute;
			right: 35px;

			.avatar-wrapper {
				cursor: pointer;
				margin-top: 5px;
				position: relative;
        color:#000;

				.user-avatar {
					width: 40px;
					height: 40px;
					border-radius: 10px;
				}

				.el-icon-caret-bottom {
					position: absolute;
					right: -20px;
					top: 20px;
					font-size: 12px;
				}
			}
		}
	}
	.langimg{
		margin-top: 15px;
		margin-left: 10px;
		cursor: pointer;
		width: 20px;
		height: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue